"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createXRAntennaCommand = exports.createAddresableCommand = exports.parseMessage = exports.UnknownCommandError = exports.InvalidArgumentError = exports.FormatType = exports.CommandType = void 0;
var CommandType;
(function (CommandType) {
    CommandType["XTALK"] = "X";
    CommandType["GENERIC"] = "G";
    CommandType["SYSTEM"] = "S";
    CommandType["DIAGNOSTIC"] = "D";
})(CommandType = exports.CommandType || (exports.CommandType = {}));
var FormatType;
(function (FormatType) {
    FormatType["SHORT"] = "A";
    FormatType["LONG"] = "B";
    FormatType["SETTING"] = "S";
})(FormatType = exports.FormatType || (exports.FormatType = {}));
class InvalidArgumentError extends Error {
    constructor(errMsg) {
        super(errMsg !== null && errMsg !== void 0 ? errMsg : 'Invalid argument error.');
        this.name = 'InvalidArgumentError';
        Object.setPrototypeOf(this, InvalidArgumentError.prototype);
    }
}
exports.InvalidArgumentError = InvalidArgumentError;
class UnknownCommandError extends Error {
    constructor(errMsg) {
        super(errMsg !== null && errMsg !== void 0 ? errMsg : 'Unknown command.');
        this.name = 'UnknownCommandError';
        Object.setPrototypeOf(this, UnknownCommandError.prototype);
    }
}
exports.UnknownCommandError = UnknownCommandError;
const SHORT_XTALK_COMMAND_REGEX = new RegExp(/^X\d{3}A\[\d{1,3}\]$/, 'i');
const RFID_ANTENNA_XTALK_REGEX = new RegExp(/^XR\[P(U|B)\d{3}\]$/, 'i');
const LONG_XTALK_COMMAND_REGEX = new RegExp(/^X\d{3}B\[.{1,30}\]$/, 'i');
function parseMessage(message) {
    if (message.length === 0) {
        throw new InvalidArgumentError('Message is empty.');
    }
    let format;
    let type;
    let address;
    let command;
    const xTalkShortCommandMatch = message.match(SHORT_XTALK_COMMAND_REGEX);
    if (xTalkShortCommandMatch) {
        type = CommandType.XTALK;
        format = FormatType.SHORT;
        address = message.substr(1, 3); // i.e 008
        address = address.replace(/^0+/, '');
        command = message.slice(message.indexOf('[') + 1, message.indexOf(']'));
        const addressConverted = Number(address);
        return createAddresableCommand(command, type, addressConverted, format);
    }
    const xTalkRfidAntennaMatch = message.match(RFID_ANTENNA_XTALK_REGEX);
    if (xTalkRfidAntennaMatch) {
        type = 'antenna';
        const bracketsContents = message.slice(message.indexOf('[') + 1, message.indexOf(']'));
        const xrAntennaCmd = bracketsContents.substr(0, 2);
        const tagIndex = parseInt(bracketsContents.substr(2, 3));
        return createXRAntennaCommand(xrAntennaCmd, tagIndex);
    }
    const xTalkLongCommandMatch = message.match(LONG_XTALK_COMMAND_REGEX);
    if (xTalkLongCommandMatch) {
        type = CommandType.XTALK;
        format = FormatType.LONG;
        address = message.substr(1, 3); // i.e 008
        command = message.slice(message.indexOf('[') + 1, message.indexOf(']'));
        return createAddresableCommand(command, type, parseInt(address), format);
    }
    throw new UnknownCommandError();
}
exports.parseMessage = parseMessage;
function createAddresableCommand(command, type, address, format) {
    return {
        command,
        type,
        address,
        format,
    };
}
exports.createAddresableCommand = createAddresableCommand;
function createXRAntennaCommand(command, tagIndex) {
    return {
        type: 'antenna',
        command,
        tagIndex,
    };
}
exports.createXRAntennaCommand = createXRAntennaCommand;
//# sourceMappingURL=MessageParser.js.map